import { BaseAction } from './BaseAction';
import Locale from '../../utils/Locale';

export class DoorOpened extends BaseAction {
    public static getTitle:Function = () => Locale.gettext('Door Opened');
    public static getDescription:Function = () => Locale.gettext('The door on The Attendant was opened');
}